(function ($) {
$(document).ready(function() {
  $('.col-with-image .col-two .btn-wrapper span').click(function() {
    var className = $(this).text();
    if(className == "Read More") {
      $(this).parents('.col-two').find('.content').slideDown();
      $(this).text('Read Less');
    }
    else if(className == "Read Less") {
      $(this).parents('.col-two').find('.content').slideUp();
      $(this).text('Read More');
    }
  });
});
})(jQuery);